import React, { useEffect, useState } from "react";
import styles from "./super-admin-dashboard.module.css";
import {
  Col,
  Popconfirm,
  Row,
  Select,
  Spin,
  Table,
  Tag,
  Typography,
} from "antd";
import CustomSelect from "../../../../common/input/custom-select/custom-select";
import { Country, State } from "country-state-city";
import CustomClientMap from "../../../../components/custom-map/custom-map";
import { defaultLatLng } from "../../../../constants/common";
import ProvinceList from "../province-list/province-list";
import StatisticsCard from "../../../../components/statistics-card/statistics-card";
import { getSuperAdminStatisticsData } from "../../../../services/dashboard";
import { getInstituteLocations } from "../../../../services/institution";

const { Option } = Select;

const statisticsCard = [
  {
    key: "provinces",
    title: "Total Province",
    icon: "province-icon",
    iconBgColor: "#EBCE3D",
    iconFill: "white",
    iconStroke: "none",
    iconHeight: "28px",
    iconWidth: "28px",
  },
  {
    key: "institutions",
    title: "Total schools onboarded",
    icon: "school-icon",
    iconBgColor: "#E05A21",
    iconFill: "white",
    iconStroke: "none",
    iconHeight: "28px",
    iconWidth: "28px",
  },
  {
    key: "monthlyRevenue",
    title: "Monthly Revenue",
    icon: "revenue-icon",
    iconBgColor: "#569BF6",
    iconFill: "none",
    iconStroke: "white",
    iconHeight: "24px",
    iconWidth: "24px",
  },
  {
    key: "zimsecInstitutions",
    title: "ZIMSEC Institutions",
    icon: "building-1",
    iconBgColor: "#E05A21",
    iconFill: "none",
    iconStroke: "white",
    iconHeight: "24px",
    iconWidth: "24px",
  },
  {
    key: "cambridgeInstitutions",
    title: "Cambridge Institutions",
    icon: "building-2",
    iconBgColor: "#569BF6",
    iconFill: "none",
    iconStroke: "white",
    iconHeight: "24px",
    iconWidth: "24px",
  },
  {
    key: "otherInstitutions",
    title: "Other Institutions",
    icon: "building-3",
    iconBgColor: "#EBCE3D",
    iconFill: "none",
    iconStroke: "white",
    iconHeight: "24px",
    iconWidth: "24px",
  },
  {
    key: "totalStudent",
    title: "Total Students",
    icon: "total-student-icon",
    iconBgColor: "#569BF6",
    iconFill: "none",
    iconStroke: "white",
    iconHeight: "24px",
    iconWidth: "24px",
  },
  {
    key: "totalTeachers",
    title: "Total Teachers",
    icon: "board-stand",
    iconBgColor: "#EBCE3D",
    iconFill: "none",
    iconStroke: "white",
    iconHeight: "24px",
    iconWidth: "24px",
  },
  {
    key: "totalParents",
    title: "Total Parents",
    icon: "users-icon",
    iconBgColor: "#E05A21",
    iconFill: "none",
    iconStroke: "white",
    iconHeight: "24px",
    iconWidth: "24px",
  },
];

const SuperAdminDashboard = () => {
  const [countryList, setCountryList] = useState([]);
  const [statisticsData, setStatisticsData] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("ZW");
  const [selectedCountryName, setSelectedCountryName] = useState("Zimbabwe");
  const [schoolsData_, setSchoolsData_] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getStatisticsInfo();
    setCountryList(Country.getAllCountries);
  }, []);

  const onCountryChange = (value) => {
    setSelectedCountry(value);
    const selectedCountryName = countryList.find(
      (item) => item.isoCode === value,
    )?.name;

    if (selectedCountryName) {
      setSelectedCountryName(selectedCountryName);
    }
  };

  const getStatisticsInfo = async () => {
    try {
      const response = await getSuperAdminStatisticsData();
      if (response?.data) {
        setStatisticsData(response?.data?.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getAllSchoolLocationData = async () => {
    try {
      const params = selectedCountryName;

      const response = await getInstituteLocations(params);

      if (response.status) {
        setSchoolsData_(response?.data?.data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllSchoolLocationData();
  }, [selectedCountry]);

  return (
    <div className={styles.container}>
      <Row className={styles.cardContainer} gutter={[12, 12]}>
        {statisticsCard?.map((item) => {
          const showValue = `${statisticsData?.[item?.key] ?? 0} ${item?.key === "monthlyRevenue" ? "Z$" : ""}`;
          return (
            <Col sm={24} md={12} lg={8}>
              <StatisticsCard
                key={item?.key}
                heading_text={item?.title}
                statistic_value={showValue}
                card_bg_color={"#FFF"}
                icon_name={item?.icon}
                icon_fill={item?.iconFill}
                icon_height={item?.iconHeight}
                icon_width={item?.iconWidth}
                icon_stroke={item?.iconStroke}
                icon_container_bg_color={item?.iconBgColor}
              />
            </Col>
          );
        })}
      </Row>
      {/* <div className={styles.headerContainer}>
        <Typography className={styles.title}>Global View</Typography>
        <div className={styles.filterContainer}>
          <Typography>
            Change Country
          </Typography>
          <CustomSelect
            id={"country"}
            size="large"
            placeholder={"Select Country"}
            value={selectedCountry}
            onChange={(e) => {
              onCountryChange(e);
            }}
          >
            {countryList.map((item, index) => (
              <Option key={index} value={item?.isoCode}>
                <div className={styles.nameContainer}>
                  <img
                    src={`https://flagcdn.com/16x12/${item?.isoCode?.toLowerCase()}.png`}
                    alt="Flag"
                  />{" "}
                  <Typography>{item?.name}</Typography>
                </div>
              </Option>
            ))}
          </CustomSelect>
        </div>
      </div> */}
      {/* <div className={styles.mapContainer}>
        {loading ? (
          <div className={styles?.spinner}>
            <Spin />
          </div>
        ) : (
          <CustomClientMap markersData={schoolsData_} center={defaultLatLng} />
        )}
      </div> */}
      <div className={styles.tableContainer}>
        <ProvinceList selectedCountry={selectedCountry} />
      </div>
    </div>
  );
};
export default SuperAdminDashboard;
